module.exports = __webpack_public_path__ + "img/imagem-03-detalhada-palmeiras-02.76e25ecb.png";